import { inject } from '@angular/core';
import { CanActivateFn,  Router } from '@angular/router';
import { StorageService } from '../services/storage.service';

export const loggedGuard: CanActivateFn = (route, state) => {
  const storage = inject(StorageService);
  if (storage.isAuthenticate()) {
    return true;
  } else {
    inject(Router).navigate(['/login']);
    return false;
  }
};

export const notLoggedGuard: CanActivateFn = (route, state) => {
  const storage = inject(StorageService);
  if (!storage.isAuthenticate()) {
    return true;
  } else {
    inject(Router).navigate(['/']);
    return false;
  }
};
